export default "__VITE_ASSET__biVd7QrO__"